<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">

  <section class="section dashboard">
    <div class="pagetitle text-center">
      <h1>Privacy Policy</h1>
      <div class="div-page-description"><h5>Details about how we handle the information we collect from you</h5></div>
    </div>
    <div class="container">

      <div class="row">
        <div class="col">

          <div class="blog-post">

            <p>Your privacy is of utmost importance to us at Rank Ahead. This privacy policy outlines how we handle the information we collect from you through our website, <a [routerLink]="['/']">https://rankahead.app</a>, and other sites that we own and operate.</p>

            <p>We only request personal information when it is necessary to provide a service to you. Our collection methods are fair, lawful, and conducted with your knowledge and consent. We transparently communicate the purpose of data collection and how it will be utilized.</p>

            <p>The information we collect is retained only for the duration necessary to deliver the requested service. Any data stored is safeguarded using commercially acceptable measures to prevent loss, theft, unauthorized access, disclosure, copying, use, or modification.</p>

            <h2><b>Information We Collect From Your Google Account</b></h2>
            <p>
              We gather information about you when you use our website or services, which may include:
            </p>
            <ul>
              <li>Your Name</li>
              <li>Email Address</li>
              <li>Website names and sitemaps from your Google Search Console account</li>
            </ul>

            <p>We do not disclose personally identifying information publicly or to third parties unless required by law.</p>

            <h2><b>How We Use Your Information</b></h2>
            <p>The information we gather about you is used for the following purposes:</p>
            <ul>
              <li>Providing, enhancing, and maintaining our website and services.</li>
              <li>Communicating with you regarding your account and usage of our website or services.</li>
              <li>Safeguarding the security and reliability of our website and services.</li>
            </ul>

            <h2><b>Your Rights</b></h2>
            <p>
              As per the GDPR, you possess specific rights concerning your personal information. These rights encompass the ability to access, rectify, erase, restrict, and object to the processing of your personal data. Additionally, you have the right to data portability and the option to withdraw your consent at any given time. To enact these rights, kindly reach out to us using the provided contact information below.
            </p>

            <p>Please note that our website may include links to external sites not operated by us. We have no control over the content and practices of these sites, and we cannot assume responsibility or liability for their privacy policies.</p>

            <p>You have the option to decline providing personal information, understanding that this may affect our ability to deliver certain services to you.</p>

            <p>Your continued use of our website signifies your acceptance of our privacy practices and treatment of personal information. Should you have any questions regarding our handling of user data, please feel free to reach out to us.</p>

            <p>This policy is effective as of 27 November 2023.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
